<!-- Header -->
<div class="row align-items-center mb-3">
    <!-- Left: Back Button -->
    <div class="col-6 d-flex justify-content-start">
        <button class="btn btn-light shadow-sm rounded-circle" (click)="goBack()">
            <i class="fa-solid fa-angle-left"></i>
        </button>
    </div>

    <!-- Right: Export Button -->
    <div class="col-6 d-flex justify-content-end" *ngIf="access === 'admin'">
        <div class="export-box shadow-sm d-flex align-items-center justify-content-center px-3 py-2 rounded bg-white"
            style="white-space: nowrap; min-width: fit-content;">
            <i class="fas fa-file-export me-2 text-muted"></i>
            <span class="text-muted small fw-medium">Export</span>
        </div>
    </div>
</div>



<div class="container-fluid">

    <!-- Topbar -->
    <div class="re-topbar d-flex justify-content-between align-items-center flex-wrap mb-4">
        <div class="d-flex align-items-center flex-wrap gap-3">
            <img *ngIf="propertyData?.listingType?.toLowerCase() === 'resale'" src="assets\Real-Estate\icons\resale.png"
                alt="Home Icon" class="" width="50" height="50" />
            <img *ngIf="propertyData?.listingType?.toLowerCase() === 'sale'" src="assets\Real-Estate\icons\sale.png"
                alt="Home Icon" class="" width="50" height="50" />
            <img *ngIf="propertyData?.listingType?.toLowerCase() === 'rent'" src="assets\Real-Estate\icons\rent.png"
                alt="Home Icon" class="" width="50" height="50" />
            <span class="re-separator d-none d-md-block"></span>
            <div>

                <h5 class="mb-1 fw-bold">{{ propertyData?.title }}</h5>
                <small class="text-muted">{{ propertyData?.address +", "+ propertyData?.city }}</small>
            </div>
        </div>

        <div class="d-flex align-items-center flex-wrap mt-3 mt-lg-0">
            <div class="d-flex align-items-center gap-2 me-2">
                <!-- Insert Calendar Here -->
                <div class="re-icon-btn calendar-container" *ngIf="propertyVisitDetail">
                    <i class="bi bi-calendar2-check calendar-icon"></i>
                    <span class="calendar-date subtle-slide" id="calendar-date">
                        Visit booked for {{ propertyVisitDetail.scheduledDate | date: 'd MMMM' }} at {{
                        propertyVisitDetail.timeSlot }}
                    </span>
                </div>

                <!-- <div class="re-icon-btn calendar-container">
  <svg width="24" height="24" viewBox="0 0 24 24" class="calendar-icon-animated">
    <rect x="2" y="4" width="20" height="18" rx="2" ry="2" fill="#f8f9fa" stroke="#011044" stroke-width="2"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="#011044" stroke-width="2"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="#011044" stroke-width="2"/>
    <line x1="2" y1="10" x2="22" y2="10" stroke="#011044" stroke-width="2"/>
    

    <path d="M7 14l3 3l7-7" fill="none" stroke="green" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <animate attributeName="stroke-dashoffset" from="20" to="0" dur="0.6s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="1;1;0" keyTimes="0;0.8;1" dur="6s" repeatCount="indefinite"/>
    </path>
  </svg>
</div> -->



                <!-- Shortlist Toggle -->
                <div class="re-icon-btn position-relative">
                    <input type="checkbox" id="shortlist-toggle" class="d-none" />
                    <label class="shortlist-toggle-img" (click)="toggleShortlist()">
                        <!-- <ng-container *ngIf="isShortlisted; else notShortlisted">
                            <img src="assets/Real-Estate/icons/shortlisted.png" alt="Shortlisted" width="22" height="20"
                                class="filled" />
                        </ng-container>
                        <ng-template #notShortlisted>
                            <img src="assets/Real-Estate/icons/shortlist.png" alt="Shortlist" width="22" height="20"
                                class="outline" />
                        </ng-template> -->

                        <img [src]="isShortlisted ? 'assets/Real-Estate/icons/shortlisted.png' : 'assets/Real-Estate/icons/shortlist.png'"
                            alt="Shortlist" width="22" height="20" class="outline" style="cursor: pointer;" />
                    </label>

                </div>

                <div class="re-icon-btn">
                    <img src="assets\Real-Estate\icons\share.png" alt="Share" width="20" height="20"
                        (click)="openShareListingModal()" />
                </div>
            </div>

            <span class="re-separator d-none d-md-block"></span>
            <span class=" text-success d-inline-flex align-items-center gap-1">
                <img src="assets\Real-Estate\icons\verified.png" alt="Verified" width="25" height="25" />
                <span class="fw-semibold gradient-text-verified">Verified</span>
            </span>

            <span class="re-separator d-none d-md-block"></span>
            <div class="text-primary-dark text-end position-relative d-inline-block">
                <div class="fw-semibold px-2" style="font-size: 16px;">₹80,000/Month</div>
                <small class="text-muted px-2">
                    Estimated EMI
                    <i class="bi bi-info-circle ms-1 text-muted" (mouseenter)="showInfo = true"
                        (mouseleave)="showInfo = false"></i>
                </small>

                <!-- Custom hover component -->
                <div *ngIf="showInfo" class="emi-tooltip shadow rounded p-2">
                    <div><strong>Amount:</strong> ₹ {{ propertyData?.price }}</div>
                    <div><strong>Tenure:</strong> 20 yrs</div>
                    <div><strong>Monthly Payment:</strong> ₹80,000</div>
                </div>
            </div>

            <span class="re-separator d-none d-md-block"></span>
            <span class="px-2 fw-bold">₹ {{ formatIndianCurrency(propertyData?.price!) }}</span>
            <span class="re-separator d-none d-md-block"></span>
            <button class="btn btn-sm btn-custom-filled">Apply for loan</button>
        </div>
    </div>

    <!-- calendar -->

    <div *ngIf="propertyVisitDetail"
        class="visit-notification d-flex justify-content-between align-items-center px-3 py-2 rounded shadow-sm my-3 bg-white flex-wrap">
        <div class="d-flex align-items-center gap-2">
            <i class="bi bi-bell-fill" style="color: #D00162; font-size: 1rem;"></i>
            <span class="fw-bold" style="color: #D00162;">
                Your visit has been scheduled on {{
                propertyVisitDetail.scheduledDate | date: 'd MMMM' }} at {{ propertyVisitDetail.timeSlot }}.
            </span>
        </div>
        <div class="d-flex gap-2 mt-2 mt-md-0">
            <button class="btn custom-action-btn-small d-flex align-items-center justify-content-center gap-1"
                (click)="openScheduleVisitModal()">
                <i class="bi bi-calendar-event me-2"></i>
                <span>Reschedule</span>
            </button>
            <button
                class="btn custom-action-btn-small cancel-btn d-flex align-items-center justify-content-center gap-1"
                (click)="cancelScheduleVisit()">
                <i class="bi bi-x-lg"></i>
                <span>Cancel Visit</span>
            </button>
        </div>

    </div>

    <!-- <div class="alert alert-warning" role="alert" *ngIf="propertyVisitDetail">
        We’ve locked in your visit for <strong>{{ propertyVisitDetail.timeSlot }}</strong> on <strong>{{
            propertyVisitDetail.scheduledDate | date: 'd MMMM' }}</strong>.
    </div> -->


    <!-- Main Content Row -->
    <div class="row mb-2">
        <div class="col-lg-6 mb-1">

            <!-- Row 1: Left Column -->
            <div class="re-box h-100 d-flex flex-column justify-content-between">

                <!-- 9 Property Details in 3x3 Grid -->
                <div class="row g-4">
                    <!-- Super Area -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\superarea.png" width="24" height="24" alt="Super Area" />
                        <div>
                            <small class="text-muted">Super Area</small><br />
                            <span class="fw-semibold">{{ propertyData?.superArea }} sq.ft.</span>
                        </div>
                    </div>

                    <!-- Carpet Area -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\carpet.png" width="23" height="23" alt="Carpet Area" />
                        <div>
                            <small class="text-muted">Carpet Area</small><br />
                            <span class="fw-semibold">{{ propertyData?.carpetArea }} sq.ft.</span>
                        </div>
                    </div>

                    <!-- Posted On -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\posted.png" width="26" height="26" alt="Posted On" />
                        <div>
                            <small class="text-muted">Posted On</small><br />
                            <span class="fw-semibold">{{ propertyData?.listedOn | date:'d MMMM y' }}</span>
                        </div>
                    </div>

                    <!-- Bedrooms -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\bedroom.png" width="26" height="26" alt="Bedrooms" />
                        <div>
                            <small class="text-muted">Bedrooms</small><br />
                            <span class="fw-semibold">{{ propertyData?.bhk != null ? propertyData?.bhk : '-' }}</span>
                        </div>
                    </div>

                    <!-- Bathrooms -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\bathroom.png" width="26" height="26" alt="Bathrooms" />
                        <div>
                            <small class="text-muted">Bathrooms</small><br />
                            <span class="fw-semibold">2</span>
                        </div>
                    </div>

                    <!-- Possession -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\possesion.png" width="26" height="26" alt="Possession" />
                        <div>
                            <small class="text-muted">Possession</small><br />
                            <span class="fw-semibold">{{ propertyData?.availableFrom | date: 'd MMMM Y'}}</span>
                        </div>
                    </div>

                    <!-- Apartment -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\apartment.png" width="26" height="26" alt="Apartment" />
                        <div>
                            <small class="text-muted">Apartment</small><br />
                            <span class="fw-semibold">Neel Sankul CHS</span>
                        </div>
                    </div>

                    <!-- Backup -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\powerbackup.png" width="26" height="26" alt="Backup" />
                        <div>
                            <small class="text-muted">Backup</small><br />
                            <span class="fw-semibold">Generator</span>
                        </div>
                    </div>

                    <!-- Water -->
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\water.png" width="26" height="26" alt="Water" />
                        <div>
                            <small class="text-muted">Water</small><br />
                            <span class="fw-semibold">24 hrs</span>
                        </div>
                    </div>
                </div>
                <!-- Posted By Card -->
                <div class="mt-2 p-3 rounded" style="background-color: #f9f9f9;">
                    <div class="re-section-title mb-2">Posted by</div>
                    <div class="d-flex align-items-center gap-3 mb-3">
                        <img [src]="propertyData?.logoUrl || 'assets/images/default-profile.png'" width="48" height="48"
                            class="rounded-circle border" alt="Profile" />
                        <div>
                            <div class="fw-semibold d-flex align-items-center gap-1">
                                {{ propertyData?.businessName }}
                                <img src="assets\Real-Estate\icons\verified.png" alt="Verified" width="20"
                                    height="20" />
                            </div>
                            <small class="text-muted">{{ propertyData?.businessType }}</small>
                        </div>
                    </div>

                    <!-- Side-by-side Buttons or Phone Number -->
                    <div class="row mb-1">
                        <div class="col-6">
                            <button class="btn btn-custom-outline btn-sm w-100" (click)="openScheduleVisitModal()"
                                style="height: 35px; border-radius: 6px;">
                                <img src="assets\Real-Estate\icons\schedule.png"
                                    alt="Schedule Icon" />&nbsp;&nbsp;Schedule Visit
                            </button>
                        </div>
                        <div class="col-6 d-flex align-items-center">
                            <ng-container *ngIf="!showPhoneNumber; else showNumber">
                                <button class="btn btn-custom-filled btn-sm w-100" (click)="onContactClick()"
                                    style="height: 35px; border-radius: 6px;">
                                    <img src="assets\Real-Estate\icons\call.png" style="height: 19px;"
                                        alt="Contact Icon" />&nbsp;&nbsp;Contact
                                </button>
                            </ng-container>
                            <ng-template #showNumber>
                                <a href="tel:{{phoneNumber}}" class="phone-number-display text-primary-dark fw-semibold"
                                    style="font-size: 16px;">
                                    {{ phoneNumber }}
                                </a>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <!-- Help Text -->
                <div class="text-start ">
                    <small class="text fw-semibold">Found something wrong in listing? <a
                            (click)="openReportListingModal()" style="cursor: pointer;"
                            class="text-danger text-decoration-none">Report here</a></small>
                </div>



            </div>


        </div>
        <div class="col-lg-6 mb-1">
            <div class="re-box h-100 d-flex flex-column">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="re-section-title-not">Media</div>
                    <!-- <i class="bi bi-pencil-square"></i> -->
                </div>

                <!-- Image Section Body -->
                <div class="d-flex gap-3">
                    <!-- Main Image -->
                    <div class="flex-grow-1" (click)="openImgPreviewModal()" style="cursor: pointer;">
                        <img [src]="propertyImages.length > 0 ? propertyImages[0].imgPath : 'assets/Real-Estate/Illustrations/NoImageFound.jpg'"
                            class="img-fluid rounded-3 w-100" style="height: 343px; object-fit: cover;"
                            alt="Main Image">
                    </div>

                    <!-- Thumbnail List (only shown if there are 2 or more images) -->
                    <div *ngIf="propertyImages.length >= 2" class="d-flex flex-column gap-2"
                        style="width: 90px; cursor: pointer;" (click)="openImgPreviewModal()">
                        <!-- Thumbnail 1 (shown if 2 or more images) -->
                        <img [src]="propertyImages[1].imgPath" class="img-fluid rounded-3"
                            style="height: 109px; object-fit: cover;" alt="Thumb 1">

                        <!-- Thumbnail 2 (shown if 3 or more images) -->
                        <img *ngIf="propertyImages.length >= 3" [src]="propertyImages[2].imgPath"
                            class="img-fluid rounded-3" style="height: 109px; object-fit: cover;" alt="Thumb 2">

                        <!-- Thumbnail 3 with overlay (shown if 4 or more images) -->
                        <div *ngIf="propertyImages.length >= 4" class="position-relative rounded-3 overflow-hidden"
                            style="height: 109px;">
                            <img [src]="propertyImages[3].imgPath" class="img-fluid w-100 h-100"
                                style="object-fit: cover;" alt="More Images">
                            <div *ngIf="propertyImages.length > 4"
                                class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-75 text-white fw-semibold fs-6 rounded-3">
                                +{{ propertyImages.length - 4 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Row 2: Overview + Activity -->
    <div class="row mt-3 align-items-stretch">
        <!-- Overview Section (Left) -->
        <div class="col-lg-8 d-flex">
            <div class="re-box w-100">
                <div class="re-section-title-not">Overview</div>
                <div class="row gy-3 text-muted">
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\buildingage.png" width="28" height="28" alt="Age">
                        <div>
                            <small>Age of Building</small><br>
                            <span class="fw-semibold">
                                {{ propertyData?.ageOfConstruction != null ? propertyData?.ageOfConstruction + ' years'
                                : '-' }}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\ownership.png" width="28" height="28" alt="Ownership">
                        <div>
                            <small>Ownership Type</small><br>
                            <span class="fw-semibold">
                                {{ propertyData?.ownershipType != null ? propertyData?.ownershipType : '-' }}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\maintainance.png" width="28" height="28" alt="Maintenance">
                        <div>
                            <small>Maintenance Charges</small><br>
                            <span class="fw-semibold">₹3.5/sq.ft/m</span>
                        </div>
                    </div>
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\furnished.png" width="28" height="28" alt="Furnishing">
                        <div>
                            <small>Furnishing Status</small><br>
                            <span class="fw-semibold">
                                {{ propertyData?.furnishing != null ? propertyData?.furnishing : '-' }}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\facing.png" width="28" height="28" alt="Facing">
                        <div>
                            <small>Facing</small><br>
                            <span class="fw-semibold">
                                {{ propertyData?.facing != null ? propertyData?.facing : '-' }}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\floor.png" width="28" height="28" alt="Floors">
                        <div>
                            <small>Floors</small><br>
                            <span class="fw-semibold">
                                {{ propertyData?.floorNumber != null && propertyData?.totalFloors != null
                                ? propertyData?.floorNumber + '/' + propertyData?.totalFloors
                                : propertyData?.floorNumber != null
                                ? propertyData?.floorNumber
                                : '-' }}
                            </span>
                        </div>
                    </div>
                    <!-- <div class="col-md-4 d-flex gap-2 align-items-start">
                        <img src="assets\Real-Estate\icons\security.png" width="28" height="28" alt="Security">
                        <div>
                            <small>Gated Security</small><br>
                            <span class="fw-semibold">Yes</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <!-- Activity Section (Right) -->
        <div class="col-lg-4 d-flex">
            <div class="re-box w-100">
                <div class="re-section-title-not">Activity On This Property</div>

                <div class="d-flex align-items-center gap-2 mb-2 p-3 rounded" style="background-color: #EEF9FE;">
                    <img src="assets\Real-Estate\icons\view.png" width="26" height="20" alt="Viewers" />
                    <span class="text">Viewers:</span>
                    <span class="fw-semibold ms-auto">106</span>
                </div>

                <div class="d-flex align-items-center gap-2 mb-2 p-3 rounded" style="background-color: #F4EDFC;">
                    <img src="assets\Real-Estate\icons\shortlist.png" width="24" height="20" alt="Shortlists" />
                    <span class="text">Shortlists:</span>
                    <span class="fw-semibold ms-auto">38</span>
                </div>

                <div class="d-flex align-items-center gap-2 p-3 rounded" style="background-color: #EEFEF3;">
                    <img src="assets\Real-Estate\icons\contact.png" width="22" height="22" alt="Contacted" />
                    <span class="text">Contacted:</span>
                    <span class="fw-semibold ms-auto">55</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Row 3: Amenities + Similar Properties -->
    <div class="row mt-3">
        <!-- Amenities Section (Single Line 8 Boxes) -->
        <div class="col-lg-8">
            <div class="re-box">
                <div class="re-section-title-not">Amenities</div>

                <!-- If amenities exist -->
                <div *ngIf="amenitiesList?.length && amenitiesList.length > 0; else noAmenities"
                    class="d-flex flex-wrap">

                    <!-- Show first 8 amenities -->
                    <div *ngFor="let amenity of amenitiesList.slice(0, 5)" class="text-center" style="flex: 0 0 12.5%;">
                        <div class="p-3 rounded-3 bg-light d-flex align-items-center justify-content-center mx-1"
                            style="height: 70px;">
                            <ng-container *ngIf="amenity.iconPath; else defaultIcon">
                                <i [class]="amenity.iconPath" style="font-size: 24px;"></i>
                            </ng-container>
                            <ng-template #defaultIcon>
                                <img src="assets/Real-Estate/icons/default.png" width="30" height="30"
                                    alt="{{ amenity.amenityName }}" />
                            </ng-template>
                        </div>
                        <div class="mt-2 small fw-medium text-muted">{{ amenity.amenityName || 'Unknown' }}</div>
                    </div>

                    <!-- "More" box -->
                    <div *ngIf="amenitiesList.length > 8" class="text-center" style="flex: 0 0 12.5%;">
                        <div class="p-3 rounded-3 bg-light d-flex align-items-center justify-content-center mx-1"
                            style="height: 70px; cursor: pointer;" data-bs-toggle="modal"
                            data-bs-target="#amenitiesModal">
                            <img src="assets/Real-Estate/icons/more.png" width="20" height="20" alt="More" />
                        </div>
                        <div class="mt-2 gradient-text">More</div>
                    </div>
                </div>
            </div>

            <!-- No Amenities Message -->
            <ng-template #noAmenities>
                <div class="d-flex align-items-center justify-content-center py-4 text-muted"
                    style="font-size: 15px; font-weight: 500;">
                    <i class="fa-regular fa-circle-xmark me-2" style="font-size: 18px; color: #999;"></i>
                    No amenities available for this property
                </div>
            </ng-template>

            <!-- Description Section -->
            <div class="re-box mt-3">
                <div class="re-section-title-not">Description</div>
                <input type="checkbox" class="read-more-state" id="post-1" />
                <h4 class="read-more-wrap text-muted mb-0">
                    This spacious 3BHK apartment offers a blend of luxury and comfort...
                    <p class="read-more-target text-muted">
                        With 24x7 water supply, power backup, and high-end security...
                    </p>
                </h4>
                <label for="post-1" class="read-more-trigger small"></label>
            </div>


        </div>



        <!-- Similar Properties Section (Right) -->
        <div class="col-lg-4">
            <div class="re-box">
                <div class="re-section-title-not">Similar Properties</div>

                <!-- Property 1 -->
                <div class="card shadow-sm rounded-3 mb-2 p-2"
                    style="box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); border: 0px;">
                    <div class="d-flex">
                        <img src="https://teja12.kuikr.com/is/a/c/655x525/gallery_images/original/cf5ca32dc7c18eb.gif"
                            class="rounded-3 me-3" style="width: 72px; height: 72px; object-fit: cover;"
                            alt="Property 1">
                        <div class="flex-grow-1">
                            <div class="fw-semibold">2BHK, Neel Sankul CHS</div>
                            <div class="text-muted small ">Location</div>

                            <div class="d-flex justify-content-between align-items-center ">
                                <div class="text-muted small">₹1.2 Cr · 1200 sq.ft</div>
                                <a href="#" style="text-decoration: none; color: #011044; font-weight: 600;">View
                                    Details</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Property 2 -->
                <div class="card shadow-sm rounded-3 mb-2 p-2"
                    style="box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); border: 0px;">
                    <div class="d-flex">
                        <img src="https://teja12.kuikr.com/is/a/c/655x525/gallery_images/original/cf5ca32dc7c18eb.gif"
                            class="rounded-3 me-3" style="width: 72px; height: 72px; object-fit: cover;"
                            alt="Property 1">
                        <div class="flex-grow-1">
                            <div class="fw-semibold">2BHK, Neel Sankul CHS</div>
                            <div class="text-muted small ">Location</div>
                            <div class="d-flex justify-content-between align-items-center ">
                                <div class="text-muted small">₹1.2 Cr · 1200 sq.ft</div>
                                <a href="#" style="text-decoration: none; color: #011044;  font-weight: 600;">View
                                    Details</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Property 3 -->
                <div class="card shadow-sm rounded-3  p-2"
                    style="box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); border: 0px;">
                    <div class="d-flex">
                        <img src="https://teja12.kuikr.com/is/a/c/655x525/gallery_images/original/cf5ca32dc7c18eb.gif"
                            class="rounded-3 me-3" style="width: 72px; height: 72px; object-fit: cover;"
                            alt="Property 1">
                        <div class="flex-grow-1">
                            <div class="fw-semibold">2BHK, Neel Sankul CHS</div>
                            <div class="text-muted small ">Location</div>
                            <div class="d-flex justify-content-between align-items-center ">
                                <div class="text-muted small">₹1.2 Cr · 1200 sq.ft</div>
                                <a href="#" style="text-decoration: none; color: #011044;  font-weight: 600;">View
                                    Details</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Row 4: Business Overview -->
    <div class="row mt-3">
        <!-- Left Column: About Business -->
        <div class="col-lg-8">
            <div class="re-box">


                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="re-section-title-not mb-0">About - {{ propertyData?.businessName }}</div>
                    <a href="#" class="btn explore-btn px-4 py-1 fw-semibold text-white rounded-3">Explore</a>
                </div>



                <!-- Profile + Stats (image on left, stats on right) -->
                <div class="d-flex align-items-center gap-3 mb-3">
                    <img [src]="propertyData?.logoUrl || 'assets/images/default-profile.png'" width="60" height="60"
                        class="rounded-circle border" style="background-position: center; background-size: cover;"
                        alt="Business Profile" />
                    <div class="flex-grow-1">
                        <div class="fw-semibold">
                            <span>Total Projects:</span> <strong>40</strong> &nbsp;&nbsp;|&nbsp;&nbsp;
                            <span>Experience:</span> <strong>5 yrs</strong>
                        </div>
                    </div>
                </div>

                <!-- Description Below Text -->
                <div class="mt-2">
                    <p class="text-muted mb-0">
                        We are a trusted real estate firm with a legacy of delivering premium residential and
                        commercial
                        projects. Our team emphasizes quality construction, timely delivery, and customer
                        satisfaction
                        above all else. With a strong presence in key locations and an expert design team, we
                        continue
                        to redefine urban living with innovative and sustainable developments.
                    </p>
                </div>
            </div>
        </div>

        <!-- Right Column (optional placeholder) -->
        <div class="col-lg-4">
            <!-- Add content here if needed -->
        </div>
    </div>

    <!-- Row 5: Locate on Map + Nearby Places -->
    <div class="row mt-3">
        <div class="col-12">
            <div class="re-box">
                <div class="re-section-title-not mb-3">Locate Property on map</div>

                <div class="position-relative" style="border-radius: 12px; overflow: hidden;">
                    <div class="d-flex h-100 flex-wrap flex-md-nowrap">
                        <!-- Left: Ola Map -->
                        <div class="flex-grow-1 position-relative" style="min-width: 300px;">
                            <!-- Ola Maps container -->
                            <div id="map" style="width: 100%; height: 400px; border-radius: 8px;"></div>
                        </div>

                        <!-- Right Tab Section -->
                        <div class="tab-sidebar h-100 p-3 overflow-auto shadow-sm rounded-end"
                            style="width: 350px; background: #fff; border: 1px solid #ddd;">
                            <!-- Tabs -->
                            <ul class="nav nav-tabs custom-tabs border-0 mb-3 gap-1" id="neighbourTab" role="tablist">
                                <li class="nav-item">
                                    <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#transit"
                                        type="button">Transit</button>
                                </li>
                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#essentials"
                                        type="button">Essentials</button>
                                </li>
                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#utility"
                                        type="button">Utility</button>
                                </li>
                            </ul>

                            <!-- Tab Content -->
                            <div class="tab-content small">
                                <div class="tab-pane fade show active" id="transit">
                                    <div class="fw-semibold text-muted mb-2">🚍 Bus Stations</div>
                                    <ul class="list-group list-group-flush mb-3">
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            Sanpada Depot <span class="text-muted">4.4 km | 11 mins</span>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            Nerul Bus Station <span class="text-muted">2.2 km | 6 mins</span>
                                        </li>
                                    </ul>
                                    <div class="fw-semibold text-muted mb-2">🚉 Train Stations</div>
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            Nerul Station <span class="text-muted">2.1 km | 6 mins</span>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            Juinagar <span class="text-muted">1.4 km | 5 mins</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="tab-pane fade" id="essentials">
                                    <div class="fw-semibold text-muted mb-2">🏥 Hospitals</div>
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            ACTREC Tata Hospital <span class="text-muted">1.1 km | 5 mins</span>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            Thunga Hospital <span class="text-muted">1.4 km | 6 mins</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="tab-pane fade" id="utility">
                                    <div class="fw-semibold text-muted mb-2">🛒 Grocery</div>
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            D-Mart <span class="text-muted">1.8 km | 5 mins</span>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between px-0">
                                            Reliance Fresh <span class="text-muted">2.1 km | 6 mins</span>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <!-- End Right Sidebar -->
                    </div>
                </div>

            </div>
        </div>
    </div>








    <!-- All Amenities Modal -->
    <div class="modal fade" id="amenitiesModal" tabindex="-1" aria-labelledby="amenitiesModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content rounded-4">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="amenitiesModalLabel">All Amenities</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Dynamically render each category -->
                    <div *ngFor="let group of groupedAmenities" class="mb-4">
                        <h6 class="re-section-title-not mb-3">{{ group.category }}</h6>
                        <div class="d-flex flex-wrap gap-3">
                            <div *ngFor="let amenity of group.amenities" class="text-center" style="width: 90px;">
                                <div class="p-3 rounded-3 border bg-light d-flex align-items-center justify-content-center"
                                    style="height: 70px;">
                                    <i [class]="amenity.iconPath || 'fa-solid fa-circle-question'"
                                        [attr.aria-label]="amenity.amenityName || 'Amenity'"></i>
                                </div>
                                <div class="mt-2 small fw-medium text-muted">{{ amenity.amenityName || 'Unknown' }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Fallback if no amenities -->
                    <div *ngIf="groupedAmenities.length === 0" class="text-center text-muted">
                        No amenities available for this property.
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- SEJAL CHANGE HERE -->
<ng-template #shareTemplate>
    <div class="modal-body">
        <p>Copy and share the link below:</p>
        <div class="input-group mb-3">
            <input type="text" class="form-control" [value]="shareLink" readonly id="shareInput" />
            <button class="btn btn-outline-primary" (click)="copyLink()">Copy</button>
        </div>
        <div *ngIf="linkCopied" class="text-success mb-3">Link copied to clipboard!</div>

        <p>Or share via:</p>
        <div class="d-flex gap-3">
            <!-- WhatsApp -->
            <a [href]="whatsAppLink" target="_blank" class="btn btn-success d-flex align-items-center gap-1">
                <i class="bi bi-whatsapp"></i> WhatsApp
            </a>

            <!-- Twitter -->
            <a [href]="twitterLink" target="_blank" class="btn btn-info text-white d-flex align-items-center gap-1">
                <i class="bi bi-twitter"></i> Twitter
            </a>

            <!-- Email -->
            <a [href]="emailLink" class="btn btn-secondary d-flex align-items-center gap-1">
                <i class="bi bi-envelope"></i> Email
            </a>
        </div>
    </div>

</ng-template>






<!-- 
  <div class="p-5 pt-2">

    <div class="property-header">
      <div class="property-title">{{propertyData?.title}}</div>
      <div class="property-location"><i class="fas fa-map-marker-alt"></i>{{propertyData?.address}}</div>
      <div class="property-price"><i class="fas fa-rupee-sign"></i> {{listingData?.price}} </div>
      <div class="tags">
        <div class="tag">Under Construction</div>
        <div class="tag">Sea Facing</div>
        <div class="tag">Corner Unit</div>
        <div class="tag">Club Membership</div>
        <div class="tag">RERA Approved</div>
      </div>
    </div>


    <div class="main-grid">
      <div class="carousel" id="carousel">
        <button class="carousel-button prev">❮</button>
        <img src="https://via.placeholder.com/1200x600?text=Living+Room" alt="Living Room" id="carousel-img">
        <button class="carousel-button next">❯</button>
        <div class="carousel-dots" id="carousel-dots"></div>
      </div>

      <div class="details-card">
        <div class="detail"><span><i class="fas fa-ruler-combined"></i> Carpet Area</span><span> {{detailsData?.carpetArea}} sq.ft.</span></div>
        <div class="detail"><span><i class="fas fa-bed"></i> Bedrooms</span><span>2</span></div>
        <div class="detail"><span><i class="fas fa-bath"></i> Bathrooms</span><span>2</span></div>
        <div class="detail"><span><i class="fas fa-car"></i> Parking</span><span>1 Covered</span></div>
        <div class="detail"><span><i class="fas fa-calendar-check"></i> Possession</span><span>Dec 2025</span></div>
        <div class="detail"><span><i class="fas fa-layer-group"></i> Floor</span><span> {{detailsData?.floorNumber}} of {{detailsData?.totalFloors}}</span></div>
        <div class="detail"><span><i class="fas fa-compass"></i> Facing</span><span> {{detailsData?.facing}} </span></div>
      </div>
    </div>


    <div class="poster-card">
      <h2 class="section-title"><i class="fas fa-user"></i> Posted By</h2>
      <div class="poster">
        <img src="https://via.placeholder.com/80?text=A" alt="Agent">
        <div class="poster-info">
          <h4>{{userRolesData?.fullName}}</h4>
          <span>Owner / Agent</span>
          <span><i class="fas fa-phone"></i> {{userRolesData?.contactNumber}} </span>
          <span><i class="fas fa-envelope"></i> {{userRolesData?.email}} </span>
          <span><i class="fas fa-clock"></i> Posted: {{listingData?.createdOn}} </span>
        </div>
      </div>
    </div>


    <div class="poster-card">
      <h2 class="section-title"><i class="fas fa-info-circle"></i> Property Overview</h2>
      <div class="overview-grid">
        <div class="overview-item"><i class="fas fa-home"></i><span>Apartment</span></div>
        <div class="overview-item"><i class="fas fa-exclamation-triangle"></i><span>Under Construction</span></div>
        <div class="overview-item"><i class="fas fa-eye"></i><span>Sea Facing</span></div>
        <div class="overview-item"><i class="fas fa-handshake"></i><span>Freehold</span></div>
        <div class="overview-item"><i class="fas fa-arrows-alt"></i><span>1050 sq.ft</span></div>
        <div class="overview-item"><i class="fas fa-layer-group"></i><span>7 / 15 Floors</span></div>
        <div class="overview-item"><i class="fas fa-street-view"></i><span>East Gate Entrance</span></div>
        <div class="overview-item"><i class="fas fa-certificate"></i><span>RERA Approved</span></div>
      </div>
    </div>


    <div class="amenities-card">
      <h2 class="section-title"><i class="fas fa-concierge-bell"></i> Amenities</h2>
      <div class="amenities">
        <div class="amenity"><i class="fas fa-dumbbell"></i><span>Gym</span></div>
        <div class="amenity"><i class="fas fa-swimmer"></i><span>Swimming Pool</span></div>
        <div class="amenity"><i class="fas fa-child"></i><span>Play Area</span></div>
        <div class="amenity"><i class="fas fa-shield-alt"></i><span>24/7 Security</span></div>
        <div class="amenity"><i class="fas fa-couch"></i><span>Club House</span></div>
        <div class="amenity"><i class="fas fa-power-off"></i><span>Power Backup</span></div>
        <div class="amenity"><i class="fas fa-wifi"></i><span>Wi-Fi Lobby</span></div>
        <div class="amenity"><i class="fas fa-tree"></i><span>Landscaped Garden</span></div>
        <div class="amenity"><i class="fas fa-bicycle"></i><span>Cycling Track</span></div>
      </div>
    </div>


    <div class="poster-card">
      <h2 class="section-title"><i class="fas fa-align-left"></i> Description</h2>
      <p class="description">
        {{propertyData?.description}}
      </p>
    </div>


    <div class="loan-calculator">
      <h2 class="section-title"><i class="fas fa-calculator"></i> Loan Calculator</h2>
      <div class="calculator-form">
        <div>
          <label>Loan Amount (₹)</label>
          <input type="number" id="loanAmount" value="8500000" min="100000" step="10000">
        </div>
        <div>
          <label>Interest Rate (%)</label>
          <input type="number" id="interestRate" value="8.5" min="1" step="0.1">
        </div>
        <div>
          <label>Loan Tenure (Years)</label>
          <input type="number" id="loanTenure" value="20">
        </div>
        <button onclick="calculateEMI()" class="contact-btn" style="margin-top: 15px;">
          <i class="fas fa-calculator"></i> Calculate EMI
        </button>
        <div class="calculator-result" id="emiResult">
          Your estimated monthly EMI will appear here...
        </div>
      </div>
    </div>


    <div class="services-card">
      <h2 class="section-title"><i class="fas fa-building"></i> Nishwik Services</h2>
      <div class="service-list">
        <div class="service"><i class="fas fa-hand-holding-usd"></i><p>Home Loans</p></div>
        <div class="service"><i class="fas fa-piggy-bank"></i><p>Savings Accounts</p></div>
        <div class="service"><i class="fas fa-file-invoice"></i><p>Property Insurance</p></div>
        <div class="service"><i class="fas fa-chart-line"></i><p>Investment Advice</p></div>
        <div class="service"><i class="fas fa-wallet"></i><p>Digital Wallet</p></div>
        <div class="service"><i class="fas fa-university"></i><p>Loan Approval</p></div>
        <div class="service"><i class="fas fa-shield-alt"></i><p>Financial Planning</p></div>
        <div class="service"><i class="fas fa-home"></i><p>Property Valuation</p></div>
      </div>
    </div>


    <div class="contact-btn">
      <button><i class="fas fa-phone"></i> Contact Owner / Agent</button>
    </div>
  </div> -->

<!-- <script>
    const imgs = [
      { src: 'https://via.placeholder.com/1200x600?text=Living+Room', alt: 'Living Room' },
      { src: 'https://via.placeholder.com/1200x600?text=Bedroom', alt: 'Bedroom' },
      { src: 'https://via.placeholder.com/1200x600?text=Pool+View', alt: 'Pool View' },
      { src: 'https://via.placeholder.com/1200x600?text=Kitchen', alt: 'Kitchen' }
    ];
    let current = 0;
    const carouselImg = document.getElementById('carousel-img');
    const dotsContainer = document.getElementById('carousel-dots');

    // Initialize carousel dots
    imgs.forEach((img, index) => {
      const dot = document.createElement('div');
      dot.className = 'dot';
      if (index === 0) dot.classList.add('active');
      dot.onclick = () => {
        current = index;
        updateCarousel();
      };
      dotsContainer.appendChild(dot);
    });

    function updateCarousel() {
      carouselImg.style.opacity = 0;
      setTimeout(() => {
        carouselImg.src = imgs[current].src;
        carouselImg.alt = imgs[current].alt;
        carouselImg.style.opacity = 1;
        document.querySelectorAll('.dot').forEach((dot, index) => {
          dot.classList.toggle('active', index === current);
        });
      }, 200);
    }

    document.querySelector('.prev').onclick = () => {
      current = (current - 1 + imgs.length) % imgs.length;
      updateCarousel();
    };
    document.querySelector('.next').onclick = () => {
      current = (current + 1) % imgs.length;
      updateCarousel();
    };


    setInterval(() => {
      current = (current + 1) % imgs.length;
      updateCarousel();
    }, 5000);

 
    function calculateEMI() {
      const loanAmount = parseFloat(document.getElementById('loanAmount').value);
      const interestRate = parseFloat(document.getElementById('interestRate').value) / 100 / 12;
      const loanTenure = parseFloat(document.getElementById('loanTenure').value) * 12;
      const emi = (loanAmount * interestRate * Math.pow(1 + interestRate, loanTenure)) /
                  (Math.pow(1 + interestRate, loanTenure) - 1);
      const result = document.getElementById('emiResult');
      result.innerHTML = `Your estimated monthly EMI: ₹${emi.toFixed(2)}`;
    }
  </script> -->